import { lazy } from 'react'

import { RouteConfig } from 'packages/route'

/**
 * 获取路由
 *
 * @returns 路由定义
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'task/announcement/:taskMsg',
    getTitle: () => '公告',
    name: 'AnnouncementTask',
    component: lazy(() =>
      import('./pages/Announcement').then((m) => ({
        default: m.Announcement,
      }))
    ),
  },
]
